export default "__VITE_ASSET__CgyB6vqe__"